import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ReactComponent as MicIcon } from 'assets/icons/chat/mic.svg'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import s from './NoteTakerHeaderAction.module.scss'
import { useIsMobileSm } from 'shared/hooks/useBreakpoint'

const NoteTakerHeaderAction = observer(() => {
	const [isHovered, setIsHovered] = useState(false)
	const isMobileSm = useIsMobileSm()

	const handleClick = async () => {
		if (noteTakerStore.isProcessing || noteTakerStore.isStarting) return

		if (!noteTakerStore.shouldShowWidget) {
			await noteTakerStore.startRecording()
			return
		}

		if (noteTakerStore.isRecording) {
			await noteTakerStore.pauseRecording()
			return
		}

		if (noteTakerStore.isPaused) {
			await noteTakerStore.resumeRecording()
		}
	}

	let label = 'Start Recording'
	if (noteTakerStore.isStarting) {
		label = 'Starting...'
	} else if (noteTakerStore.isSavingSession) {
		label = 'Saving...'
	} else if (noteTakerStore.isAiProcessingFailed) {
		label = 'Processing failed'
	} else if (noteTakerStore.isAiProcessingActive) {
		label = 'Converting...'
	} else if (noteTakerStore.isProcessing) {
		label = 'Saving...'
	} else if (noteTakerStore.isPaused) {
		label = `Paused ${noteTakerStore.recordingLabel}`
	} else if (noteTakerStore.isRecording) {
		const canShowPause = noteTakerStore.recordingSeconds > 2
		label =
			isHovered && canShowPause
				? `Pause ${noteTakerStore.recordingLabel}`
				: `Recording ${noteTakerStore.recordingLabel}`
	} else if (isMobileSm) {
		label = 'Recording'
	}

	const isDisabled =
		noteTakerStore.isProcessing ||
		noteTakerStore.isStarting ||
		noteTakerStore.isSubmittingSession ||
		noteTakerStore.isAiProcessingActive

	return (
		<button
			type="button"
			data-note-taker-trigger
			className={[
				s.button,
				noteTakerStore.isRecording ? s.buttonRecording : '',
				noteTakerStore.isPaused ? s.buttonPaused : '',
				noteTakerStore.isProcessing || noteTakerStore.isStarting
					? s.buttonProcessing
					: '',
			]
				.filter(Boolean)
				.join(' ')}
			onClick={handleClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			disabled={isDisabled}
		>
			<span className={s.iconWrap}>
				{noteTakerStore.isRecording || noteTakerStore.isPaused ? (
					<span className={s.dot} />
				) : null}
				<MicIcon />
			</span>
			<span className={s.label}>{label}</span>
		</button>
	)
})

export default NoteTakerHeaderAction
